import If from './If/If'
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable , variableRender) {
    if(action.actionName === types.IF || action.actionName === types.ELSEIF) {
        return <If action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender}/>;
    }
}

export default Actions;
